import { RootState } from 'store';

export const selectDeviceType = (state: RootState) => state.services.device.type;
export const selectIsDeviceTypeMobile = (state: RootState) => selectDeviceType(state) === 'mobile';
export const selectIsDeviceTypeTablet = (state: RootState) => selectDeviceType(state) === 'tablet';
export const selectIsDeviceTypeDesktop = (state: RootState) =>
  selectDeviceType(state) === 'desktop';
export const selectIsDeviceLandscape = (state: RootState) =>
  state.services.device.orientation === 'landscape';
